














































































import { DraftCompanyParams } from '@/store/interfaces/drafts';
import drafts from '@/store/types/drafts';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import InboundCard from './inboundCard.vue';
import DescriptionValue from '@/components/Reusable/descriptionValue.vue';
import BankAccountsForm from './forms/bankAccounts.vue';
import { BankParams } from '@/store/interfaces/bankAccount';
import bankAccount from '@/store/types/bankAccount';
import { VuexFunction } from '@/ts/axios';

@Component({ components: { InboundCard, DescriptionValue, BankAccountsForm, }, })
export default class BankAccounts extends Vue {
  isLoading = true;
  edit = false;
  editThrows(value: boolean): void {
    this.edit = value;
  }

  get howRecieveStatement(): { name: string; email: string; phone: string } {
    const contact = {
      name: String(this.draftCompany.name),
      phone: String(this.draftCompany.phone),
      email: String(this.draftCompany.email),
    };

    if (this.draftCompany.accountant_contact) {
      contact.name = String(this.draftCompany.accountant_contact_name);
      contact.phone = String(this.draftCompany.accountant_contact_phone);
      contact.email = String(this.draftCompany.accountant_contact_email);
    }
    return contact;
  }

  async mounted(): Promise<void> {
    await this.bankAccount();
    this.isLoading = false;
  }

  @Getter(`drafts/${drafts.getters.GET_DRAFT_COMPANY}`)
  draftCompany!: DraftCompanyParams;

  @Action(`companyModule/bankAccount/${bankAccount.actions.BANKS_LIST}`)
  bankAccount!: VuexFunction<BankParams>;

  @Getter(`companyModule/bankAccount/${bankAccount.getters.GET_BANKS_LIST}`)
  getBanks!: BankParams[];
}
